import React from "react";
import madLogo from "../assets/mad-logo.png";

export default function AppHeader({
  title = "MAD ABOUT DIGITAL",
  subtitle,
  right,
  showLogo = true,
}) {
  return (
    <div
      style={{
        width: "100%",
        padding: "22px 20px",
        borderRadius: 14,
        marginBottom: 22,
        background: "linear-gradient(120deg, #000000 0%, #ffcc33 100%)",
        color: "white",
        boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 18,
        flexWrap: "wrap",
      }}
    >
      <div style={{ minWidth: 240 }}>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, letterSpacing: -0.3 }}>
          {title}
        </h1>
        {subtitle ? (
          <p style={{ margin: 0, marginTop: 6, opacity: 0.92, fontWeight: 600 }}>
            {subtitle}
          </p>
        ) : null}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          marginLeft: "auto",
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        {right ? <div>{right}</div> : null}

        {showLogo ? (
          <img
            src={madLogo}
            alt="MAD Logo"
            style={{
              height: 52,
              width: "auto",
              objectFit: "contain",
              filter: "drop-shadow(0 6px 14px rgba(0,0,0,0.25))",
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
